import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AnyByIdPipe } from './pipes/any-by-id.pipe';
import { DeletedPipe } from './pipes/deleted.pipe';
import { ValCartTotalPipe } from './pipes/val-cart-total.pipe';
import { ValImageLoadedPipe } from './pipes/val-image-loaded.pipe';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [
        AnyByIdPipe,
        DeletedPipe,
        ValCartTotalPipe,
        ValImageLoadedPipe
    ],
    exports: [
        AnyByIdPipe,
        DeletedPipe,
        ValCartTotalPipe,
        ValImageLoadedPipe
    ],
    providers: []
})
export class ValCommonModule { }
